import React from 'react';
import classNames from 'classnames';
import AntdInputGroup from 'antd/es/input/Group';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import warning from 'antd/es/_util/warning';
const Group = (props) => {
    const { size, className, disabled, children, bordered = true, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const animation = React.useContext(AnimationContext);
    const prefixCls = getPrefixCls('input-group', props.prefixCls);
    if (process.env.NODE_ENV !== 'production')
        warning(props.bordered !== false, 'input.group', `'bordered = false' is deprecated now`);
    warning(props.theme !== 'gray', 'input.group', `'themes = gray' is deprecated now`);
    const mergedClassnames = classNames({
        [`${prefixCls}-xs`]: size === 'xs',
        [`${prefixCls}-disabled`]: disabled === true,
        [`${prefixCls}-breathing`]: !!animation?.breathing
    }, className);
    // Add disabled and theme props to children.
    const mergedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            const newProps = {};
            newProps['size'] = size;
            newProps['bordered'] = 'true';
            if (disabled) {
                newProps['disabled'] = true;
            }
            return React.cloneElement(child, newProps);
        }
        return child;
    });
    if (size !== 'xs') {
        otherProps.size = size;
    }
    return (React.createElement(AntdInputGroup, { prefixCls: prefixCls, className: mergedClassnames, ...otherProps }, mergedChildren));
};
export default Group;
// export default withConfigProvider(Group);
